export function getCalendarGridChipTooltip({
  hasTitleOverflow,
  hint,
  title,
  tooltip,
}) {
  return tooltip ?? hint ?? (hasTitleOverflow ? title : null)
}
